import { useEffect, useState } from "react";
import CloseIcon from "@mui/icons-material/Close";
import { Button, Grid, Modal } from "@mui/material";
import Box from "@mui/material/Box";
import { ErrorMessage } from "formik";
import { useTranslation } from "react-i18next";
import Field from "../../component/Field";
import Label from "../../component/Label";
import SelectField from "../../component/SelectField";
import { DateTimeUtil } from "../../util/DateTimeUtils";
import dayjs from "dayjs";
import SimpleDate from "../../component/simpleDate";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "400px",
  bgcolor: "background.paper",
  border: "2px solid #000",
  borderRadius: "10px",
  boxShadow: 24,
  p: 4,
  zIndex: 999999999,
};

const ParentLinkStudentInfo = (props: any) => {
  const {
    values,
    handleChange,
    handleBlur,
    errors,
    touched,
    setFieldValue,
    schoolOption,
  } = props;
  const { t } = useTranslation();
  const [getAge, setAge] = useState<number>(0);
  const [dateOfBirthChageFlag, setDateOfBirthChageFlag] =
    useState<boolean>(false);

  const today = new Date();
  const dateFormat = process.env.REACT_APP_DEFAULT_DATE_FORMAT;

  let age = today?.getFullYear() - values?.dob?.$d?.getFullYear();

  useEffect(() => {
    if (!isNaN(age)) {
      setDateOfBirthChageFlag(true);
      setAge(age);
    } else {
      setDateOfBirthChageFlag(false);
      setAge(0);
    }
  }, [age]);
  const [modalOpen, setModalOpen] = useState(false);

  // const handleModalOpen = () => {
  //   setModalOpen(true);
  //   props.handleDrawerClose(true);
  // };
  const handleModalClose = () => {
    setModalOpen(false);
    props.handleDrawerClose(false);
  };

  const handleDateChange = (
    date: any,
    onload: boolean,
    setFieldValue?: any
  ) => {
    if (setFieldValue) {
      setFieldValue("dob", date);
    }
    const selectedDate = new Date(
      !onload ? date : DateTimeUtil.format(date, dateFormat, true)
    );
    if (selectedDate) {
      const today = new Date();
      const calculatedAge = today.getFullYear() - selectedDate.getFullYear();
      if (!onload) {
        setDateOfBirthChageFlag(true);
        setAge(calculatedAge);
      }
      return calculatedAge;
    } else {
      return 0;
    }
  };

  return (
    <Box>
      <Grid
        container
        rowSpacing={1}
        columnSpacing={{ xs: 1, sm: 2, md: 3 }}
        style={{ padding: "10px" }}
      >
        <Grid item xs={12} sm={6} md={4} lg={4}>
          <div style={{ paddingRight: "20px" }}>
            <Label required title={t("studentName")} />
            <Field
              name="studentName"
              placeholder={t("enterHere")}
              value={values.studentName}
              onChange={handleChange}
              onBlur={handleBlur}
              error={errors.studentName && touched.studentName}
            />
            <div className="form-ele-gap autocomplete-form">
              <Label required title={t("gender")} />
              <SelectField
                name="gender"
                value={values.gender || t("select")}
                onChange={handleChange}
                options={[
                  {
                    label: `${t("male")}`,
                    value: `${t("male")}`,
                  },
                  {
                    label: `${t("female")}`,
                    value: `${t("female")}`,
                  },
                  {
                    label: `${t("others")}`,
                    value: `${t("others")}`,
                  },
                ]}
                helperText={<ErrorMessage name="gender" />}
                error={errors.gender && touched.gender}
              />
            </div>
          </div>
        </Grid>
        <Grid item xs={12} sm={6} md={4} lg={4}>
          <div className="flex">
            <div>
              <Label required title={t("dob(DD/MM/YYYY)")} />
              <div className="compact-date-picker">
                <SimpleDate
                  className="textFiled"
                  name="dob"
                  value={dayjs(values?.dob)}
                  onChange={(e: any) => {
                    handleDateChange(e, false, setFieldValue);
                  }}
                  disableFuture
                  format={dateFormat}
                  onBlur={handleBlur}
                  helperText={<ErrorMessage name="dob" />}
                  error={touched?.dob && errors?.dob}
                />
              </div>
            </div>
            <div className="padding-left-10">
              <Label title={t("age")} />
              <Field
                className="textFiled"
                disabled
                name="age"
                value={dateOfBirthChageFlag ? getAge : values?.age}
                onChange={handleChange}
                onBlur={handleBlur}
                error={errors.age && touched.age}
              />
            </div>
          </div>
        </Grid>
        <Grid item xs={12} sm={6} md={4} lg={4}>
          <div>
            <Label title={t("school")} />
            <SelectField
              name="school"
              style={{ width: "100%" }}
              value={values.school || t("select")}
              onChange={handleChange}
              onBlur={handleBlur}
              options={schoolOption}
              error={errors.school && touched.school}
            />
          </div>
        </Grid>
      </Grid>
      {/* modal */}
      <div>
        <Modal
          open={modalOpen}
          onClose={handleModalClose}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box sx={style}>
            <div
              style={{
                borderBottom: "1px solid #E6E6E6",
                padding: "12px",
                marginBottom: "45px",
              }}
            >
              <div
                className="flex"
                style={{
                  justifyContent: "space-between",
                }}
              >
                <Label title={"Add Student"} />
                <CloseIcon
                  onClick={handleModalClose}
                  style={{ cursor: "pointer" }}
                />
              </div>
            </div>

            <div
              style={{
                textAlign: "right",
                borderTop: "1px solid #E6E6E6",
                marginTop: "15px",
                paddingTop: "15px",
              }}
            >
              <Button className="clear-btn2" style={{ marginRight: "10px" }}>
                {t("clear")}
              </Button>
              <Button className="createUser-btn" onClick={handleModalClose}>
                {t("submit")}
              </Button>
            </div>
          </Box>
        </Modal>
      </div>
    </Box>
  );
};

export default ParentLinkStudentInfo;
